var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "HKLModal",
    {
      ref: "modal",
      staticClass: "green-operation_status-lifecycle",
      attrs: {
        closeable: true,
        size: _vm.modalSize,
        title: _vm.$t("tenancy.greenOperation.lifecycleTitle"),
      },
    },
    [
      _c("HKLTable", {
        staticClass: "lifecycle",
        attrs: {
          dataSource: _vm.histories,
          columns: _vm.columns,
          sort: "createdAt",
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "row align-center",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c("HKLButton", {
            attrs: { color: "orange", action: "ok" },
            on: { click: _vm.close },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }